import { BASE_URL } from '@/api/index';
import axios, { AxiosRequestConfig } from 'axios';
import { WhatsAppMessageTemplate } from 'ignite360-core';

export class WhatsAppApi {
  static async getTemplates(botId: string): Promise<WhatsAppMessageTemplate[]> {
    const config: AxiosRequestConfig = {
      method: 'GET',
      url: `${BASE_URL}/public/bots/${botId}/whatsapp/templates`,
    };

    try {
      const result = await axios.request(config);
      // Ensure we're returning plain objects, not Vue observables
      const templates = JSON.parse(JSON.stringify(result.data));
      return templates;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || error.message || 'Unknown error occurred';

      throw new Error(errorMessage);
    }
  }

  static async sendTemplateMessage(
    phoneNumber: string,
    templateName: string,
    botId: string,
    parameters?: Record<string, string>,
  ): Promise<void> {
    const config: AxiosRequestConfig = {
      method: 'POST',
      url: `${BASE_URL}/public/bots/${botId}/whatsapp/send-template`,
      data: {
        phoneNumber,
        templateName,
        parameters,
      },
    };

    try {
      const result = await axios.request(config);
      return result.data;
    } catch (error: any) {
      // Extract the error message from the response
      const errorMessage =
        error.response?.data?.message || error.message || 'Unknown error occurred';

      throw new Error(errorMessage);
    }
  }
}
